import "./LinkedinLogin.scss"

import classNames from "classnames"
import React, { useEffect, useRef } from "react"
import { useSelector } from "react-redux"

import ConnectingToStreamLoader from "../../atoms/ConnectingToStreamLoader"
import Stream from "../Stream"

const LinkedinLogin = ({ onStreamEnd, onDisconnect, centerContent }) => {
  const streamRef = useRef()

  const stream = useSelector(state => state.account.stream)

  // used to send request for end streaming when user leave the page
  useEffect(() => {
    if (stream.status === "success") {
      window.addEventListener("beforeunload", onStreamEnd)
    }

    return () => {
      if (stream.status === "success") {
        window.removeEventListener("beforeunload", onStreamEnd)
      }
    }
  }, [stream.status])

  const linkedinLoginWrapperClassName = classNames("linkeidn-login-wrapper", {
    "linkeidn-login-wrapper-centered": centerContent,
  })

  return (
    <div className={linkedinLoginWrapperClassName}>
      {stream.status === "free" || stream.status === "starting" ? (
        <ConnectingToStreamLoader />
      ) : (
        <Stream
          src={stream.url}
          password={stream.password}
          onDisconnect={onDisconnect}
          streamRef={streamRef}
        />
      )}
    </div>
  )
}

export default LinkedinLogin
